import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { generatePath } from "react-router";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { Trans, useTranslation } from "react-i18next";
import YearbookPoseIcon from "@mui/icons-material/MenuBook";
import React, { useMemo, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import { priceListHaveDigitalPictureProducts } from "@/react/Webshop/utils/digitalPictureUtils";
import DigitalFileIcon from "@/react/components/Icons/DigitalFileIcon";
import PackageIcon from "@/react/components/Icons/PackageIcon";
import { useTheme } from "@mui/material/styles";
import SelectJobPoseDialog from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/SelectJobPoseDialog";
const useStyles = makeStyles((theme) => ({
    pictureSetActionList: {
        margin: 0,
        padding: 0,
        listStyle: "none",
        display: "inline-flex",
        flexWrap: "wrap",
        justifyContent: "center",
        "& > li": {
            margin: theme.spacing(0.5),
        },
    },
}));
function YearbookPoseButtonIfSupport({ pictureSet, }) {
    const yearbookPoseSelection = pictureSet.job.yearbookPoseSelection;
    const routes = useMobileRoutes();
    const [showSelectPoseDialog, setShowSelectPoseDialog] = useState(false);
    if (!pictureSet.qualifyForSelectYearbookPose) {
        return null;
    }
    const to = generatePath(routes["myaccount.picturesets.pictureset.yearbookpose.job-pose"].path, {
        uuid: pictureSet.subject.uuid,
        jobPoseUuid: yearbookPoseSelection.poses[0].uuid,
    });
    const btnProps = yearbookPoseSelection.poses.length > 1
        ? { onClick: () => setShowSelectPoseDialog(true) }
        : { component: Link, to };
    return (React.createElement("li", null,
        React.createElement(Button, Object.assign({ variant: "outlined", color: "primary", startIcon: React.createElement(YearbookPoseIcon, null) }, btnProps),
            React.createElement(Trans, null, "Set yearbook pose")),
        showSelectPoseDialog && (React.createElement(SelectJobPoseDialog, { pictureSet: pictureSet, onClose: () => setShowSelectPoseDialog(false) }))));
}
const PictureSetActions = ({ pictureSet }) => {
    const routes = useMobileRoutes();
    const classes = useStyles();
    const priceList = usePriceList();
    const [t] = useTranslation();
    const theme = useTheme();
    const canBuydigital = useMemo(() => {
        return priceListHaveDigitalPictureProducts(priceList, t);
    }, [priceList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", justifyContent: "center", mb: 2 },
            React.createElement("ul", { className: classes.pictureSetActionList },
                pictureSet.qualifyForSelectOwnFavorites && (React.createElement("li", null,
                    React.createElement(Button, { variant: "outlined", color: "primary", component: Link, to: generatePath(routes["myaccount.picturesets.pictureset.favorites"].path, { uuid: pictureSet.subject.uuid }), startIcon: React.createElement(FavoriteBorderIcon, null) },
                        React.createElement(Trans, null, "Set favorites")))),
                React.createElement(YearbookPoseButtonIfSupport, { pictureSet: pictureSet }),
                canBuydigital && (React.createElement("li", null,
                    React.createElement(Button, { variant: "outlined", color: "primary", component: Link, to: generatePath(routes["products.digitalportraits.subject"].path, { subjectUuid: pictureSet.subject.uuid }), startIcon: React.createElement(DigitalFileIcon, { color: theme.palette.primary.main }) },
                        React.createElement(Trans, null, "Buy digital files")))),
                React.createElement("li", null,
                    React.createElement(Button, { variant: "outlined", color: "primary", component: Link, to: routes["products.list"].path, startIcon: React.createElement(PackageIcon, { color: theme.palette.primary.main }) },
                        React.createElement(Trans, null, "Buy products")))))));
};
export default PictureSetActions;
